module.exports = __webpack_public_path__ + "vg.4236b3592713a56c25d1.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/portal/bullseye/node_modules/flag-icon-css/flags/1x1/vg.svg
// module id = ../../../../flag-icon-css/flags/1x1/vg.svg
// module chunks = styles